import { useEffect, useState } from "react";

/**
 * Debounce a primitive value. The first render returns `value` immediately;
 * subsequent changes are deferred by `delayMs`. A delay of 0 still defers to
 * the next tick to avoid render loops.
 *
 * Designed for primitives (string/number/boolean). Object/array values will
 * fire the debounced update on every reference change even when content is
 * identical, pass primitives only.
 */
export function useDebounce<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState<T>(value);

  useEffect(() => {
    const timer = window.setTimeout(() => setDebounced(value), delayMs);
    return () => window.clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
